import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93c716c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row justify-start" }

import { DisplayObjectDataModel } from 'components/global-common/DisplayObjectData.model';
import DisplayProperty from 'components/global-common/DisplayProperty.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisplayObject',
  props: {
    displayObjectData: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["col", _ctx.displayObjectData.class])
      }, _toDisplayString(props.displayObjectData.description), 3)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayObjectData.displayProperties, (displayProperty) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["col-1", displayProperty.class]),
          key: displayProperty.class
        }, [
          _createVNode(DisplayProperty, {
            label: displayProperty.label,
            value: displayProperty.value
          }, null, 8, ["label", "value"])
        ], 2))
      }), 128))
    ])
  ], 64))
}
}

})